import { getCreditReport } from '../api/checks'
import type { Resolvers } from '../generated/server/resolvers'

const CreditReportResolvers: Resolvers = {
  Query: {
    creditReport: async (_, { useClientApi, clientId }) => {
      return await getCreditReport(useClientApi, clientId)
    },
  },
}

export default CreditReportResolvers
